import React from "react";
import { useNavigate } from "react-router-dom"; // Updated hook
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Container,
} from "reactstrap";

// Import card data
import scanCards from "../../../common/data/scancards";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const VulnerabilityScan = () => {
  document.title = "Scan Cards";

  const navigate = useNavigate(); // Updated hook for navigation

  // Function to handle card click and navigate to ScanOptions
  const handleCardClick = (scanType) => {
    navigate(`/scanOptions/${scanType}`); // Redirect with scanType parameter
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Scan" breadcrumbItem="Artifacts" />
        
          <Row className="d-flex align-items-stretch">
            {scanCards.map((card, index) => (
              <Col lg={3} md={6} sm={12} key={index} className="mb-4">
                <Card
                  className="mb-4"
                  style={{ height: "100%", cursor: "pointer" }}
                  onClick={() => handleCardClick(card.scanType)} // Handle click event
                >
                  <CardBody className="d-flex flex-column ">
                    <CardTitle className="mb-4">
                      <i className={`${card.icon} me-3`} /> {card.title}
                    </CardTitle>
                    <CardText>{card.description}</CardText>
                    <p className="card-text">
                      <small className="text-muted">{card.timestamp}</small>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VulnerabilityScan;
